export default __webpack_public_path__ + "static/media/graphic-24.052699da.png";